	<template>
	<div id="sideBar" class="flex column bCenter">
    <div>
      <el-menu
        :router="true"
        class="el-menu-vertical-demo"
        :default-openeds="[ defaultOpen ]">
          <div
            v-for="(item,pindex) in sideBarList"
            :key="pindex"
            >
            <el-menu-item
              :myPath="pindex+'_0_'+item.id"
              v-if="item.children?!item.children.length:null"
              :index="pindex+'_0_'+item.id+'?menuid='+($route.query.menuid || '')"
              @click="onSelectChange(item)"
              :class="{'is-active':isActive(pindex,true)}"
              >
              <template slot="title">
                <!-- <span class="status" :class="item.studyComplete | isComplete"></span> -->
                <span class="title text-overflow" style="font-weight:600;color:#606266;width: 240px;display: inline-block;" :title="item.name">{{ item.name }}</span>
              </template>
            </el-menu-item>

            <el-submenu
              v-else
              :index="pindex.toString()">
              <template slot="title">
                <span :title="item.name" class="text-overflow">{{ item.name }}</span>
              </template>
                <!-- :class="{'is-active':isActive(pindex+'_'+cindex,false) }" -->
              <el-menu-item
                :myPath="lessonType(citem).routeLink+'/'+pindex+'_'+cindex+'_'+citem.id"
                v-for="(citem,cindex) in item.children"
                :key="cindex"
                :class="{'is-active':pindex+'_'+cindex+'_'+citem.id == $route.params.id ? true :false }"
                :index="pindex+'_'+cindex+'_'+citem.id+'?menuid='+($route.query.menuid || '')"
                @click="onSelectChange(citem,pindex+'_'+cindex+'_'+citem.id)"
                >
                <!-- <span class="status" v-if="citem.studyComplete == undefined" :class="citem.examRet | isComplete"></span> -->
                <!-- <span class="status" v-else :class="citem.studyComplete | isComplete"></span> -->
                <span class="title text-overflow" :title="citem.name">{{ citem.name }}</span>
                <span
                  class="type"
                  :class="lessonType(citem).className"
                  >
                    {{ lessonType(citem).rType }}
                  </span>
              </el-menu-item>
            </el-submenu>
          </div>

      </el-menu>
		</div>
		<!-- <div class="tip flex aCenter" v-if="showBar">
			<p>
				<span class="status"></span>未开始
			</p>
			<p>
				<span class="status doing"></span>进行中
			</p>
			<p>
				<span class="status finnish"></span>已完成
			</p>
		</div> -->
	</div>
</template>


<script>
import { getExamList } from '@/service/api/methods/educationCloud';
export default {
	props: {
		sideBarList: {
		  type: Array
    },
    showBar: {
      type:Boolean,
      default:false
    }
	},
	data() {
		return {
      path: 0,
      //当前选中的菜单项配置信息
      activeLesson: {
        // id:0,//课件id
        type: 0, //课件类型
        routeLink: "", //跳转路由 documentDetails/videoDetails
        rType: "", //课件类型字符串PDF-视频-
        className: "" //添加样式  默认为蓝色，test：测验
      }
		};
  },
  filters:{
    isComplete(value){
      if(!value){
        return ''
      }
      switch (value) {
        case 0:
          return 'doing'
          break;
        case 1:
          return 'finnish'
          break;
        case -1:
          return '';
          break;
      }
    }
  },
  computed:{
    defaultOpen(){
      if(this.$route.params.id){
        let arr = [];
        arr = this.$route.params.id.split('_');
        return arr[0];
      }
    }
  },
	methods: {
		lessonType(item) {
      if(item.type){
        switch (item.type) {
          case 0:
            return {
              rType: "PDF",
              className: "",
              routeLink: this.$utils.lessonTypeUrl(item.type)
            };

            break;
          case 1:
            return {
              rType: "视频",
              className: "",
              routeLink: this.$utils.lessonTypeUrl(item.type)
            };
            break;
          case 2:
            return {
              rType: "课件",
              className: "",
              routeLink: this.$utils.lessonTypeUrl(item.type)
            };
            break;
          case 3:
            return {
              rType: "考试",
              className: "examination",
              routeLink: this.$utils.lessonTypeUrl(item.type)
            };
            break;
        }
      }else{
        return {
          rType: "测验",
          className: "test",
          routeLink: this.$utils.lessonTypeUrl(item.type)
        };
      }

    },
    //判断是否当前选中
		isActive(value, isTitle) {
      if(this.$route.params.id){
        if (isTitle) {
          return value == this.$route.params.id.slice(0, 1) ? true : false;
        }else{
          return value == this.$route.params.id.slice(0, 3) ? true : false;
        }
      }
    },
    findBroth(){
      if(!this.sideBarList[this.$route.params.id.split('_')[0]].children[this.$route.params.id.split('_')[1]-1])
      return
      if(this.activeLesson.className == 'test'){
        // console.log(this.sideBarList[this.$route.params.id.split('_')[0]].children[this.$route.params.id.split('_')[1]-1])
        return this.sideBarList[this.$route.params.id.split('_')[0]].children[this.$route.params.id.split('_')[1]-1].studyComplete == 1 ? true :false;
      }
    },
    //选中菜单项
		onSelectChange(item,path) {
      sessionStorage.setItem('info',JSON.stringify(item));
      this.activeLesson = this.lessonType(item);
      this.$router.push({
        path:`/online-learning${this.activeLesson.routeLink}/${this.$route.params.id}`,
        query:this.$route.query
      });
    }
	}
};
</script>

<style lang="less" scoped>
@import "./sideBar.less";
</style>
